import Axios, { CancelTokenSource } from "axios";

import { defaultErrorResponse } from "api/defaults";

import { API } from "utils/api-config";

import {
    ActivityLogPagination,
    IActionFilter,
} from "store/environments/tenants/tenant-activity-log/tenant-activity-log-types";

export const loadActivityLog = async (
    environmentMoniker: string,
    tenantMoniker: string,
    pageIndex?: number,
    pageSize?: number,
    stateDate?: string | null,
    endDate?: string | null,
    actionFilters?: IActionFilter[] | null,
    cancelTokenSource?: CancelTokenSource
): Promise<[ActivityLogPagination | null, number]> => {
    if (!environmentMoniker || !tenantMoniker) {
        return defaultErrorResponse;
    }

    const response = await API.post(
        `/environments/${environmentMoniker}/tenants/${tenantMoniker}/activity-logs?pageIndex=${pageIndex}&pageSize=${pageSize}&startDate=${
            stateDate ?? ""
        }&endDate=${endDate ?? ""}`,
        actionFilters,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadActionFilters = async (
    environmentMoniker: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[IActionFilter[] | null, number]> => {
    if (!environmentMoniker || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `/environments/${environmentMoniker}/tenants/${tenantId}/activity-logs/action-filters`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
